import {Space} from "antd";
import {SubSettingsFormFields} from "../../../general/settings/sub-settings";
import {BundlePauseSettingFormField} from "./pause-setting";
import {SessionSettingsFormFieldsProps} from "../../session/settings/types";

export function BundleSessionSettingsFormFields({
  formType,
}: SessionSettingsFormFieldsProps) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {formType === "edit" && <BundlePauseSettingFormField />}
      <SubSettingsFormFields
        requestCustomerPhoneNumberLabel="Request customer's phone number"
        hideFromProfileLabel="Hide session from your profile page "
        showUrlRedirect={false}
      />
    </Space>
  );
}
